// MapsBantuan.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix untuk icon default Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Komponen untuk mengatur view map
const MapController = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, zoom);
    }
  }, [center, map, zoom]);
  return null;
};

const MapsBantuan = ({ latitude, longitude, alamat, nama }) => {
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (latitude && longitude) {
        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          setPosition([lat, lng]);
        } else {
          setError('Koordinat tidak valid');
        }
      } else {
        setError('Koordinat tidak tersedia');
      }
    } catch (err) {
      setError('Gagal memuat peta');
    } finally {
      setLoading(false);
    }
  }, [latitude, longitude]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error || !position) {
    return (
      <Alert severity="info" sx={{ mt: 1 }}>
        {error || 'Koordinat lokasi tidak tersedia'}
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
      <MapContainer
        center={position}
        zoom={15}
        style={{ height: '300px', width: '100%' }}
        scrollWheelZoom={true}
      >
        <MapController center={position} zoom={15} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            <Typography variant="subtitle2" fontWeight={600}>
              {nama || 'Lokasi Bantuan'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {alamat || 'Koordinat: ' + position.join(', ')}
            </Typography>
          </Popup>
        </Marker>
      </MapContainer>
      <Box sx={{ p: 1, bgcolor: '#f5f5f5' }}>
        <Typography variant="caption" color="text.secondary">
          📍 {position.join(', ')}
        </Typography>
      </Box>
    </Box>
  );
};

export default MapsBantuan;